<template>
    <div>
        <preset-bar v-model="query"/>
        <highlighted-date v-model="query.daterange" v-if="query.daterange.highlight"/>
        <daterange-picker v-model="query.daterange" v-else/>
        <widget-drag-area :query="query"/>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Watch} from 'vue-property-decorator';
    import moment from 'moment';
    import PresetBar from '../components/dashboard/PresetBar';
    import DaterangePicker from '../components/dashboard/DaterangePicker';
    import WidgetDragArea from '../components/dashboard/WidgetDragArea';
    import HighlightedDate from '../components/dashboard/HighlightedDate';

    @Component({
        components: {
            HighlightedDate,
            PresetBar,
            DaterangePicker,
            WidgetDragArea,
        }
    })
    export default class DashboardPage extends Vue {
        query = {
            daterange: {
                start: moment(),
                end: moment(),
                highlight: null,
            },
            country_id: null,
        };

        @Watch('query.daterange', {deep: true})
        onDaterangeChanged() {
            // When the daterange changes, update the browser url
            const start = this.query.daterange.start;
            const end = this.query.daterange.end;
            const route = {
                name: 'dashboard',
                params: {
                    start: start.format('YYYY-MM-DD'),
                    end: end.format('YYYY-MM-DD'),
                },
            };
            this.$router.push(route);
        }

        @Watch('$route')
        onRouteChanged() {
            const params = this.$route.params;
            let start = params.start ? moment(params.start) : moment.invalid();
            let end = params.end ? moment(params.end) : moment.invalid();
            // If an invalid date is passed, use the default range
            if (!this.isRangeValid(start, end)) {
                start = moment().subtract(7, 'days');
                end = moment();
            }
            // Only update the query if the values change
            const daterange = this.query.daterange;
            const sameRange = (start.isSame(daterange.start, 'day') && end.isSame(daterange.end, 'day'));
            if (!sameRange) {
                this.query.daterange.start = start;
                this.query.daterange.end = end;
            }
        }

        isRangeValid(start, end) {
            return start.isValid() && end.isValid() && !start.isAfter(end, 'day');
        }

        mounted() {
            this.onRouteChanged();
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/DashboardPage.vue